import * as Yup from "yup";

export const CREATE_INLINE_VENUE_MODAL_ID = "add-venue-inline-modal";

export const CREATE_VENUE_MODAL_VALIDATION_SCHEMA = Yup.object({
  name: Yup.string()
    .required()
    .label("Name"),
  city: Yup.string()
    .required()
    .label("City"),
  country: Yup.string()
    .required()
    .label("Country"),
  address: Yup.string()
    .required()
    .label("Address")
});

export const VENUE_MODAL_EMITS = {
  CREATED: "venue-created"
};
